import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import {
  CheckSuggestionsBundleRequest,
  CheckSuggestionsBundleResponse,
  EnterpriseRequiredItemsRequest,
  EnterpriseRequiredItemsResponse,
  RequiredItemsRequest,
  RequiredItemsResponse,
} from '../interfaces/reserve-add.model';

/**
 * 加選項目service
 */
@Injectable({
  providedIn: 'root',
})
export class ReserveAddService {
  http: HttpClient = inject(HttpClient);

  /**
   * 查詢加選項目
   *
   * @param request 查詢加選項目request
   */
  checkSuggestionsBundle(
    request: CheckSuggestionsBundleRequest
  ): Observable<ApiResponse<CheckSuggestionsBundleResponse>> {
    const payload: CheckSuggestionsBundleRequest = request;
    return this.http.post<ApiResponse<CheckSuggestionsBundleResponse>>(
      API_ENDPOINTS.CHECK_SUGGESTIONS_BUNDLE,
      payload
    );
  }

  /**
   * 必檢(換項)項目調整
   * @param request 必檢(換項)項目調整request
   */
  requiredItems(
    request: RequiredItemsRequest
  ): Observable<ApiResponse<RequiredItemsResponse>> {
    const payload: RequiredItemsRequest = request;
    return this.http.post<ApiResponse<RequiredItemsResponse>>(
      API_ENDPOINTS.PERSONAL_REQUIRED_ITEMS,
      payload
    );
  }


  /**
   * 企業必檢(換項)項目調整 (CB-096)
   * @param request 企業必檢(換項)項目調整request
   */
  enterpriseRequiredItems(
    request: EnterpriseRequiredItemsRequest
  ): Observable<ApiResponse<EnterpriseRequiredItemsResponse>> {
    const payload: EnterpriseRequiredItemsRequest = request;
    return this.http.post<ApiResponse<EnterpriseRequiredItemsResponse>>(
      API_ENDPOINTS.ENTERPRISE_REQUIRED_ITEMS,
      payload
    );
  } 
}